module.exports = __webpack_public_path__ + "img/67.01e13784.jpg";